__turbopack_context__.v({
  "authSkeletonShimmer": "Auth-module__mX17bW__authSkeletonShimmer",
  "button": "Auth-module__mX17bW__button",
  "card": "Auth-module__mX17bW__card",
  "container": "Auth-module__mX17bW__container",
  "error": "Auth-module__mX17bW__error",
  "footer": "Auth-module__mX17bW__footer",
  "footerText": "Auth-module__mX17bW__footerText",
  "form": "Auth-module__mX17bW__form",
  "formGroup": "Auth-module__mX17bW__formGroup",
  "header": "Auth-module__mX17bW__header",
  "hint": "Auth-module__mX17bW__hint",
  "input": "Auth-module__mX17bW__input",
  "label": "Auth-module__mX17bW__label",
  "link": "Auth-module__mX17bW__link",
  "logo": "Auth-module__mX17bW__logo",
  "logoIcon": "Auth-module__mX17bW__logoIcon",
  "profileTopBar": "Auth-module__mX17bW__profileTopBar",
  "skeletonBar": "Auth-module__mX17bW__skeletonBar",
  "skeletonStack": "Auth-module__mX17bW__skeletonStack",
  "subtitle": "Auth-module__mX17bW__subtitle",
  "title": "Auth-module__mX17bW__title",
});
